import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import PatientInteraction from 'common-src/models/PatientInteraction';
import {
  extractPatientReferral,
  getFilteredPatientReferrals,
} from 'common-src/models/PatientReferral';

import { Referrals } from 'src/components/forms';
import { getTimer } from 'src/features/timeTracker';
import useCustomSelector from 'src/hooks/useCustomSelector';
import { ModuleTitle } from 'src/pages/DocumentationIndex/components';

import styles from './ReferralsModule.module.scss';

const ReferralsModule = ({
  patientId,
  errors,
  referrals,
  setReferrals,
  setHasDetectedChanges,
  documentationToEdit,
}) => {
  const filteredPatientReferrals = useCustomSelector((state) =>
    getFilteredPatientReferrals(state, patientId),
  );
  const timer = useCustomSelector((state) => getTimer(state, patientId));

  useEffect(() => {
    const initialReferrals =
      timer &&
      documentationToEdit.primaryModuleTypeId &&
      !_.isEmpty(documentationToEdit?.draftData?.referrals)
        ? documentationToEdit?.draftData?.referrals
        : filteredPatientReferrals.map(extractPatientReferral);

    setReferrals(initialReferrals);
    setHasDetectedChanges(new Date());
  }, []);

  return (
    <div className={styles.container}>
      <ModuleTitle title="Referrals" tooltipMessage="Referrals since last neurologist visit" />
      <Referrals
        patientId={patientId}
        isEditMode
        formData={referrals}
        setFormData={(data) => {
          setReferrals(data);
          setHasDetectedChanges(new Date());
        }}
        errors={Object.fromEntries(errors)}
        setErrors={() => {}}
        patientReferrals={filteredPatientReferrals}
      />
    </div>
  );
};

ReferralsModule.propTypes = {
  patientId: PropTypes.number,
  errors: PropTypes.object,
  referrals: PropTypes.array,
  setReferrals: PropTypes.func,
  setHasDetectedChanges: PropTypes.func,
  documentationToEdit: PropTypes.exact(PatientInteraction.schema),
};

export default ReferralsModule;
